export const version = '2.18.1';
//# sourceMappingURL=version.js.map